/**
 * ./exercise9/Exercise9Intro.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise9Intro = () => {
  const navigate = useNavigate();
  const [selectedLevel, setSelectedLevel] = useState(2);
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Text will jump on the screen. Follow the text rhythm.
  </span>`
  );
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const [userData, setUserData] = useState(null);
  const levels = [2, 4, 6, 8, 10]; // List of levels

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false;
    if ((9 < userData.numExercisesUnlocked) || (9 === userData.numExercisesUnlocked && levelNumber <= userData.currNumLevelsUnlocked)) {
      return true;
    }
    return false;
  };

  const handleLevelClick = (level) => {
    setSelectedLevel(level);
  };


  const handleStartClick = () => {
    navigate("/exercise9workout");
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Focus on clear text recognition and natural understanding while maintaining <b>Rhythmic Breathing</b>.
    </span>`
    );
    setCanStart(true);
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button className="guidance-and-start-button" onClick={handleNextClick}>
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise9Intro;
